import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import './App.css';

// Layout Components
import Header from './components/Header';
import Footer from './components/Footer';
import StickyCTA from './components/StickyCTA';

// Pages
import LandingPage from './pages/LandingPage';
import PreisePage from './pages/PreisePage';
import EinsatzgebietePage from './pages/EinsatzgebietePage';
import StadtteilPage from './pages/StadtteilPage';
import RatgeberHub from './pages/RatgeberHub';
import RatgeberArticle from './pages/RatgeberArticle';
import ImpressumPage from './pages/ImpressumPage';
import DatenschutzPage from './pages/DatenschutzPage';
import KontaktPage from './pages/KontaktPage';
import SitemapHTML from './pages/SitemapHTML';
import NotFoundPage from './pages/NotFoundPage';

// Leistungen Pages
import LeistungenPage from './pages/LeistungenPage';
import TueroeffnungZugefallenPage from './pages/TueroeffnungZugefallenPage';
import TueroeffnungVerschlossenPage from './pages/TueroeffnungVerschlossenPage';
import AutooeffnungPage from './pages/AutooeffnungPage';
import TresoroeffnungPage from './pages/TresoroeffnungPage';
import SchlosswechselPage from './pages/SchlosswechselPage';
import EinbruchschutzPage from './pages/EinbruchschutzPage';
import EinbruchschadenReparaturPage from './pages/EinbruchschadenReparaturPage';

// Data
import { stadtteile, ratgeber } from './data/stadtteile';
import { Toaster } from './components/ui/sonner';

function App() {
  return (
    <BrowserRouter>
      <div className="min-h-screen flex flex-col">
        <Header />
        <main className="flex-grow">
          <Routes>
            {/* Home redirects to landing */}
            <Route path="/" element={<Navigate to="/schluesseldienst-dortmund" replace />} />
            
            {/* Main Pages */}
            <Route path="/schluesseldienst-dortmund" element={<LandingPage />} />
            <Route path="/preise" element={<PreisePage />} />
            <Route path="/einsatzgebiete" element={<EinsatzgebietePage />} />
            
            {/* Leistungen */}
            <Route path="/leistungen" element={<LeistungenPage />} />
            <Route path="/leistungen/tueroeffnung-zugefallen" element={<TueroeffnungZugefallenPage />} />
            <Route path="/leistungen/tueroeffnung-verschlossen" element={<TueroeffnungVerschlossenPage />} />
            <Route path="/leistungen/autooeffnung" element={<AutooeffnungPage />} />
            <Route path="/leistungen/tresoroeffnung" element={<TresoroeffnungPage />} />
            <Route path="/leistungen/schlosswechsel" element={<SchlosswechselPage />} />
            <Route path="/leistungen/einbruchschutz" element={<EinbruchschutzPage />} />
            <Route path="/leistungen/einbruchschaden-reparatur" element={<EinbruchschadenReparaturPage />} />
            
            {/* Ratgeber */}
            <Route path="/ratgeber" element={<RatgeberHub />} />
            
            {/* Stadtteil Pages - Explicit routes for better server compatibility */}
            {stadtteile.map((st) => (
              <Route 
                key={st.slug} 
                path={`/schluesseldienst-dortmund-${st.slug}`} 
                element={<StadtteilPage />} 
              />
            ))}
            
            {/* Ratgeber Articles - Explicit routes */}
            {ratgeber.map((r) => (
              <Route 
                key={r.slug} 
                path={`/ratgeber/${r.slug}`} 
                element={<RatgeberArticle />} 
              />
            ))}
            
            {/* Static Pages */}
            <Route path="/kontakt" element={<KontaktPage />} />
            <Route path="/impressum" element={<ImpressumPage />} />
            <Route path="/datenschutz" element={<DatenschutzPage />} />
            <Route path="/sitemap.html" element={<SitemapHTML />} />
            
            {/* 404 */}
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </main>
        <Footer />
        <StickyCTA />
        <Toaster position="top-center" richColors />
      </div>
    </BrowserRouter>
  );
}

export default App;
